import coverImage from 'assets/images/cover.jpg';
import defaultAvatar from 'assets/images/default-avatar.jpeg';
import googleLogo from 'assets/images/google.png';
import imagePlaceHolder from 'assets/images/image_placeholder.webp';
import stripeLogo from 'assets/images/stripelogo.png';
import stripeLogoWhite from 'assets/images/stripeLogoWhite.png';
import taxAndServices from 'assets/images/tax_png.png';

const images = {
  placeholderImage: imagePlaceHolder,
  coverImage,
  defaultAvatar,
  taxAndServices,
  stripeLogo,
  stripeLogoWhite,
  googleLogo,
};

export default images;
